import { createRoutesFromElements, Route } from 'react-router-dom';
import { RequireAuth } from 'components';
import Checkout from 'components/Checkout';
import {
  ReleaseLayout,
  ReleaseArtistName,
  ReleaseDetails,
  ReleaseReview,
  ReleaseTracklist,
} from 'pages';
import { locations } from './locations';

const distributionRoutes = createRoutesFromElements(
  <Route
    id="distribution"
    path={locations.distribution.pathname}
    element={
      <RequireAuth>
        <ReleaseLayout />
        <Checkout shouldBlockRedirect />
      </RequireAuth>
    }
  >
    <Route
      id="artist-name"
      path={locations.distribution.artistName.route}
      element={<ReleaseArtistName />}
    />
    <Route
      id="tracklist"
      path={locations.distribution.tracklist.route}
      element={<ReleaseTracklist />}
    />
    <Route
      id="details"
      path={locations.distribution.details.route}
      element={<ReleaseDetails />}
    />
    <Route
      id="review"
      path={locations.distribution.review.route}
      element={<ReleaseReview />}
    />
  </Route>
);

export default distributionRoutes;
